// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderStatusFormStyles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusForm";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

orderStatusFormStyles.submitButton = {
    css: css`
        margin-top: 22px;
        ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    null,
                    css`
                        margin-top: 0;
                    `,
                    null,
                ],
                "max",
            )}
    `,
};

orderStatusFormStyles.form = {
    css: css`
        @media print {
            display: none;
        }
    `,
};
